module.exports = __webpack_public_path__ + "img/Perks-25.0848f252.png";